function findProductById(products = [], productId = "") {
  return products.find(({ id }) => id === productId)
}

module.exports = {
  findProductById,
}
